export const REWARDFUL_RETRY_DELAY_MS = 2_000;
export const REWARDFUL_SCRIPT_SRC = "https://r.wdfl.co/rw.js";

export type RewardfulLoadPhase = "waiting" | "loading" | "retrying" | "loaded" | "failed";

export function rewardfulPhaseAfterError(phase: RewardfulLoadPhase): RewardfulLoadPhase {
  if (phase === "loading") return "retrying";
  return "failed";
}

export function rewardfulLoadAttempt(phase: RewardfulLoadPhase): 1 | 2 {
  return phase === "retrying" || phase === "failed" ? 2 : 1;
}

export function rewardfulScriptSrc(generation: number): string {
  if (generation <= 0) return REWARDFUL_SCRIPT_SRC;
  return `${REWARDFUL_SCRIPT_SRC}?retry=${generation}`;
}
